import React, { useEffect, useState, useCallback } from 'react';
import { addSeconds, parseISO, format } from 'date-fns';
import { GlobalState } from '@leverege/ui-redux';
import { Flex, Text } from '@leverege/ui-elements';
import LoadingScreen from "../../../../screens/support/LoadingScreen.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ResourceImageValueComponent(props) {
  // to do: make valuestyle the style of the image
  // make a more tailored model + editor for images
  const {
    value,
    path,
    valueStyle,
    clientProps,
    showCreatedAt
  } = props;
  const {
    delegate
  } = clientProps;
  const [imageUrl, setImageUrl] = useState();
  const [createdAt, setCreatedAt] = useState();
  const [loading, setLoading] = useState(false);
  const [imageEl, setImageEl] = useState();
  const ref = useCallback(node => {
    if (node) {
      setImageEl(node);
    }
  }, []);
  const getImage = useCallback((force = false) => {
    if (imageUrl === 'err') {
      return;
    }
    const rsrc = delegate.resource(path).getRsrc(GlobalState.get());
    if (!force) {
      if (rsrc) {
        const url = new URL(rsrc.data.url);
        let expiresDate;
        if (url.searchParams.has('Expires')) {
          const expires = url.searchParams.get('Expires');
          expiresDate = new Date(parseInt(expires) * 1000);
        } else if (url.searchParams.has('X-Goog-Date')) {
          const expiresIn = parseInt(url.searchParams.get('X-Goog-Expires'));
          const validAtDate = parseISO(url.searchParams.get('X-Goog-Date'));
          expiresDate = addSeconds(validAtDate, expiresIn);
        }
        if (expiresDate && expiresDate > new Date()) {
          if (rsrc.data.url) {
            setImageUrl(rsrc.data.url);
            setCreatedAt(rsrc.createdAt);
          }
          return;
        }
      }
    }
    setLoading(true);
    GlobalState.dispatch(delegate.resource(path).get()).then(data => {
      const {
        data: {
          url
        }
      } = data;
      setImageUrl(url);
      setLoading(false);
    }).catch(err => {
      setImageUrl('err');
      setLoading(false);
    });
  }, [delegate, path, imageUrl]);
  useEffect(() => {
    getImage();
  }, [value]);
  const handleIntersection = useCallback(([entry]) => {
    if (entry.isIntersecting) {
      getImage();
    }
  }, [getImage]);
  useEffect(() => {
    const observer = new IntersectionObserver(handleIntersection);
    if (imageEl) {
      observer.observe(imageEl);
    }
    return () => {
      observer.disconnect();
    };
  }, [imageEl, handleIntersection]);
  const {
    height,
    width
  } = valueStyle;
  if (loading) {
    return /*#__PURE__*/_jsx("div", {
      style: {
        height,
        width
      },
      children: /*#__PURE__*/_jsx(LoadingScreen, {
        style: {
          height,
          width
        },
        title: "loading"
      })
    });
  }
  // if there is no image, render an icon meaning there is no image
  return /*#__PURE__*/_jsxs(Flex, {
    direction: "column",
    style: {
      height: '100%',
      width: '100%'
    },
    children: [/*#__PURE__*/_jsx("img", {
      ref: ref,
      src: imageUrl,
      alt: value,
      style: {
        ...valueStyle,
        cursor: 'pointer'
      }
    }), showCreatedAt && createdAt && /*#__PURE__*/_jsxs(Text, {
      variant: "caption",
      style: {
        margin: '8px'
      },
      children: ["Created At: ", format(new Date(createdAt), 'hh:mm a MM/d/yyyy')]
    })]
  });
}